import React from "react"
import autobind from "class-autobind"
import { Card, FlatButton, CardHeader, CardText, CardActions, FontIcon, TextField, Toggle, SelectField, MenuItem } from "material-ui"
import strings from "../../../../localization/strings"
import { amber500, amber50 } from "material-ui/styles/colors"
import { IClientContactDocument, IAddress, EPreferredContactEnum, IPhoneInfo, IEmailInfo } from "../../../../models"
import SelectProfilePicture from "../../../../components/clients/select_client_contact_picture/SelectProfilePicture"
import StateSelector from "../../../../components/clients/state-selector/StateSelector"
import * as utils from "../../../../helpers/utils"
import AccountStore from "../../../../stores/AccountStore"
import cloneDeep from "lodash/cloneDeep"
import { EnumValues } from "enum-values"
import moment from "moment-timezone"
import AppStateStore from "../../../../stores/AppStateStore"
interface IProps {
    readonly: boolean
    selectedContactForEdit: IClientContactDocument
    closeDrawer(): void
    handleUpdateClientContact(clientContact: IClientContactDocument, imageData: string | boolean): void
}
interface IState {
    profilePicture: string
    imageData: string | boolean
    firstName: string
    errorFirstName: string
    lastName: string
    errorLastName: string
    preferredName: string
    title: string
    preferredContactMethod: EPreferredContactEnum
    active: boolean
    primary: boolean
    billing: boolean
    homePhone: IPhoneInfo
    homePhoneNo: string
    errorHomePhoneNo: string
    workPhone: IPhoneInfo
    workPhoneNo: string
    errorWorkPhoneNo: string
    mobilePhone: IPhoneInfo
    mobilePhoneNo: string
    errorMobilePhoneNo: string
    primaryEmail: IEmailInfo
    primaryEmailValue: string
    errorPrimaryEmailValue: string
    address: IAddress
    streetName: string
    houseOrBuliding: string
    city: string
    zip: string
    state: string
}

export default class EditClientContactForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            profilePicture: props.selectedContactForEdit.ProfileImageS3Url ? props.selectedContactForEdit.ProfileImageS3Url : "",
            imageData: null,
            firstName: props.selectedContactForEdit.FirstName,
            errorFirstName: "",
            lastName: props.selectedContactForEdit.LastName,
            errorLastName: "",
            preferredName: props.selectedContactForEdit.PreferredName ? props.selectedContactForEdit.PreferredName : "",
            title: props.selectedContactForEdit.Title ? props.selectedContactForEdit.Title : "",
            preferredContactMethod: props.selectedContactForEdit.PreferredContact,
            active: props.selectedContactForEdit.Active,
            primary: props.selectedContactForEdit.Primary,
            billing: props.selectedContactForEdit.Billing,
            homePhone: props.selectedContactForEdit.ContactInfo ? props.selectedContactForEdit.ContactInfo.HomePhone : null,
            homePhoneNo: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.HomePhone ? props.selectedContactForEdit.ContactInfo.HomePhone.PhoneNumber : "",
            errorHomePhoneNo: "",
            workPhone: props.selectedContactForEdit.ContactInfo ? props.selectedContactForEdit.ContactInfo.WorkPhone : null,
            workPhoneNo: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.WorkPhone ? props.selectedContactForEdit.ContactInfo.WorkPhone.PhoneNumber : "",
            errorWorkPhoneNo: "",
            mobilePhone: props.selectedContactForEdit.ContactInfo ? props.selectedContactForEdit.ContactInfo.MobilePhone : null,
            mobilePhoneNo: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.MobilePhone ? props.selectedContactForEdit.ContactInfo.MobilePhone.PhoneNumber : "",
            errorMobilePhoneNo: "",
            primaryEmail: props.selectedContactForEdit.ContactInfo ? props.selectedContactForEdit.ContactInfo.PrimaryEmail : null,
            primaryEmailValue: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.PrimaryEmail ? props.selectedContactForEdit.ContactInfo.PrimaryEmail.Email : "",
            errorPrimaryEmailValue: "",
            address: props.selectedContactForEdit.ContactInfo ? props.selectedContactForEdit.ContactInfo.Address : null,
            streetName: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.Address ? props.selectedContactForEdit.ContactInfo.Address.StreetName : "",
            houseOrBuliding: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.Address ? props.selectedContactForEdit.ContactInfo.Address.HouseOrBuildingName : "",
            city: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.Address ? props.selectedContactForEdit.ContactInfo.Address.CityTown : "",
            zip: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.Address ? props.selectedContactForEdit.ContactInfo.Address.PostalArea : "",
            state: props.selectedContactForEdit.ContactInfo && props.selectedContactForEdit.ContactInfo.Address ? props.selectedContactForEdit.ContactInfo.Address.GoverningDistrictOrState : "",
        }
        autobind(this)
    }

    updateClientData() {
        const clientContact: IClientContactDocument = cloneDeep(this.props.selectedContactForEdit)
        if (this.checkValidate()) {
            clientContact.FirstName = this.state.firstName.trim()
            clientContact.LastName = this.state.lastName.trim()
            clientContact.PreferredName = this.state.preferredName.trim()
            clientContact.Title = this.state.title.trim()
            clientContact.PreferredContact = this.state.preferredContactMethod
            clientContact.Active = this.state.active
            clientContact.Primary = this.state.primary
            clientContact.Billing = this.state.billing
            clientContact.ContactInfo = {
                ...clientContact.ContactInfo, HomePhone: this.state.homePhone, WorkPhone: this.state.workPhone,
                MobilePhone: this.state.mobilePhone, PrimaryEmail: this.state.primaryEmail, Address: this.state.address,
            }
            this.props.handleUpdateClientContact(clientContact, this.state.imageData)
        }
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.firstName.trim()) {
            this.setState({ errorFirstName: strings.First_Name_cannot_be_empty })
            isValidate = false
        } else {
            this.setState({ errorFirstName: "" })
        }

        if (!this.state.lastName.trim()) {
            this.setState({ errorLastName: strings.Last_Name_cannot_be_empty })
            isValidate = false
        } else {
            this.setState({ errorLastName: "" })
        }

        if (this.state.preferredContactMethod === EPreferredContactEnum.Email) {
            if (!this.state.primaryEmailValue.trim()) {
                this.setState({ errorPrimaryEmailValue: strings.This_field_is_required })
                isValidate = false
            }
            else {
                if (!utils.validateEmail(this.state.primaryEmailValue)) {
                    this.setState({ errorPrimaryEmailValue: strings.Invalid_email_format })
                    isValidate = false
                } else {
                    this.setState({ errorPrimaryEmailValue: "" })
                }
            }
        }
        else {
            if (this.state.primaryEmailValue.trim() && !utils.validateEmail(this.state.primaryEmailValue)) {
                this.setState({ errorPrimaryEmailValue: strings.Invalid_email_format })
                isValidate = false
            } else {
                this.setState({ errorPrimaryEmailValue: "" })
            }
        }

        return isValidate
    }

    render() {
        const defaultTimeZone = AccountStore.getCurrentAccountSettings() && AccountStore.getCurrentAccountSettings().LocalizationSettings && AccountStore.getCurrentAccountSettings().LocalizationSettings.DefaultIANATimezoneId
        let contactName = this.props.selectedContactForEdit !== null ? `${this.props.selectedContactForEdit.FirstName} ${this.props.selectedContactForEdit.LastName}` : ""
        if (this.props.selectedContactForEdit && this.props.selectedContactForEdit.PreferredName !== "" && this.props.selectedContactForEdit.PreferredName !== null) {
            if (this.props.selectedContactForEdit.LastName !== "" && this.props.selectedContactForEdit.LastName !== null) contactName = `${this.props.selectedContactForEdit.PreferredName} ${this.props.selectedContactForEdit.LastName}`
            else contactName = this.props.selectedContactForEdit.PreferredName
        }
        return (
            <div>
                <Card style={{ boxShadow: "none" }}>
                    <CardHeader
                        style={{ backgroundColor: AppStateStore.getFrontEndSettings().UISettings.AccentColor, height: 90, textAlign: "center" }}
                        title={
                            <h2>{contactName}</h2>
                        }
                        children={
                            <FontIcon
                                onTouchTap={() => this.props.closeDrawer()}
                                className="fa fa-close"
                                style={{ cursor: "pointer", fontSize: 25, color: amber50, position: "absolute", top: 35, left: 950 }}
                            />
                        }
                        titleColor={"white"}
                    />
                    <CardText>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <SelectProfilePicture
                                    readonly={this.props.readonly}
                                    pictureUrl={this.state.profilePicture}
                                    selectContactPicture={(imageData: string | boolean) => this.setState({ imageData })}
                                />
                                <TextField
                                    floatingLabelText={strings.First_Name}
                                    value={this.state.firstName || ""}
                                    onChange={(e, value) => { this.setState({ firstName: value }, () => this.checkValidate()) }}
                                    errorText={this.state.errorFirstName}
                                    errorStyle={{ position: "absolute", bottom: -10 }}
                                    style={{ marginTop: "-5.2%", width: 300 }}
                                    disabled={this.props.readonly}
                                />
                                <TextField
                                    floatingLabelText={strings.Last_Name}
                                    value={this.state.lastName || ""}
                                    onChange={(e, value) => { this.setState({ lastName: value }, () => this.checkValidate()) }}
                                    errorText={this.state.errorLastName}
                                    errorStyle={{ position: "absolute", bottom: -10 }}
                                    style={{ marginTop: "-5.2%", width: 300 }}
                                    disabled={this.props.readonly}
                                />
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <TextField
                                    floatingLabelText={strings.Preferred_Name}
                                    value={this.state.preferredName || ""}
                                    onChange={event => this.setState({ preferredName: event.target.value })}
                                    style={{ width: 300 }}
                                    disabled={this.props.readonly}
                                />
                                <TextField
                                    floatingLabelText={strings.Title}
                                    value={this.state.title || ""}
                                    onChange={(e, value) => { this.setState({ title: value }) }}
                                    style={{ width: 300 }}
                                    disabled={this.props.readonly}
                                />
                                <SelectField
                                    floatingLabelText={strings.Preferred_Contact_Method}
                                    value={this.state.preferredContactMethod}
                                    onChange={(event, key, preferredContactMethod) => this.setState({ preferredContactMethod }, () => this.checkValidate())}
                                    style={{ width: 300 }}
                                    disabled={this.props.readonly}
                                >
                                    {EnumValues.getValues(EPreferredContactEnum)
                                        .map((item, index) =>
                                            <MenuItem key={index} value={item} primaryText={strings[EnumValues.getNameFromValue(EPreferredContactEnum, item)]} />
                                        )
                                    }
                                </SelectField>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Toggle
                                    onToggle={(e, checked) =>
                                        this.setState({ primary: checked })
                                    }
                                    style={{ paddingTop: 30, width: 300 }}
                                    defaultToggled={this.state.primary}
                                    label={strings.Primary_Contact}
                                    disabled={this.props.readonly}
                                />
                                <Toggle
                                    onToggle={(e, checked) =>
                                        this.setState({ billing: checked })
                                    }
                                    style={{ paddingTop: 30, width: 300 }}
                                    defaultToggled={this.state.billing}
                                    label={strings.Billing_Contact}
                                    disabled={this.props.readonly}
                                />
                                <Toggle
                                    onToggle={(e, checked) =>
                                        this.setState({ active: checked })
                                    }
                                    style={{ paddingTop: 30, width: 300 }}
                                    defaultToggled={this.state.active}
                                    label={strings.Active}
                                    disabled={this.props.readonly}
                                />
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                    <div>
                                        <TextField
                                            floatingLabelText={strings.Home_Phone}
                                            value={this.state.homePhoneNo || ""}
                                            errorText={this.state.errorHomePhoneNo}
                                            errorStyle={{ position: "absolute", bottom: -10 }}
                                            style={{ width: 300 }}
                                            onChange={event => {
                                                const homePhone: IPhoneInfo = { ...this.state.homePhone, PhoneNumber: event.target.value }
                                                this.setState({ homePhoneNo: event.target.value, homePhone }, () => this.checkValidate())
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            floatingLabelText={strings.Work_Phone}
                                            value={this.state.workPhoneNo || ""}
                                            errorText={this.state.errorWorkPhoneNo}
                                            errorStyle={{ position: "absolute", bottom: -10 }}
                                            style={{ width: 300 }}
                                            onChange={event => {
                                                const workPhone: IPhoneInfo = { ...this.state.workPhone, PhoneNumber: event.target.value }
                                                this.setState({ workPhoneNo: event.target.value, workPhone }, () => this.checkValidate())
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            floatingLabelText={strings.Cell_Phone}
                                            value={this.state.mobilePhoneNo || ""}
                                            errorText={this.state.errorMobilePhoneNo}
                                            errorStyle={{ position: "absolute", bottom: -10 }}
                                            style={{ width: 300 }}
                                            onChange={event => {
                                                const mobilePhone: IPhoneInfo = { ...this.state.mobilePhone, PhoneNumber: event.target.value }
                                                this.setState({ mobilePhoneNo: event.target.value, mobilePhone }, () => this.checkValidate())
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            floatingLabelText={strings.Primary_Email}
                                            value={this.state.primaryEmailValue || ""}
                                            errorText={this.state.errorPrimaryEmailValue}
                                            errorStyle={{ position: "absolute", bottom: -10 }}
                                            style={{ width: 300 }}
                                            onChange={event => {
                                                const primaryEmail: IEmailInfo = { ...this.state.primaryEmail, Email: event.target.value.trim() }
                                                this.setState({ primaryEmailValue: event.target.value, primaryEmail }, () => this.checkValidate())
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <TextField
                                            floatingLabelText={strings.Street}
                                            value={this.state.streetName || ""}
                                            style={{ width: 300 }}
                                            onChange={event => {
                                                const address: IAddress = { ...this.state.address, StreetName: event.target.value }
                                                this.setState({ streetName: event.target.value, address })
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            floatingLabelText={strings.Address}
                                            value={this.state.houseOrBuliding || ""}
                                            style={{ width: 300 }}
                                            onChange={event => {
                                                const address: IAddress = { ...this.state.address, HouseOrBuildingName: event.target.value }
                                                this.setState({ houseOrBuliding: event.target.value, address })
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <TextField
                                            style={{ width: 140, marginRight: 15 }}
                                            floatingLabelText={strings.City}
                                            value={this.state.city || ""}
                                            onChange={event => {
                                                const address: IAddress = { ...this.state.address, CityTown: event.target.value }
                                                this.setState({ city: event.target.value, address })
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                        <TextField
                                            style={{ width: 140 }}
                                            floatingLabelText={strings.Zip_Postal_code}
                                            value={this.state.zip || ""}
                                            onChange={event => {
                                                const address: IAddress = { ...this.state.address, PostalArea: event.target.value }
                                                this.setState({ zip: event.target.value, address }, () => this.checkValidate())
                                            }}
                                            disabled={this.props.readonly}
                                        />
                                    </div>
                                    <div>
                                        <StateSelector
                                            state={this.state.state}
                                            handleState={state => {
                                                const address: IAddress = { ...this.state.address, GoverningDistrictOrState: state }
                                                this.setState({ state, address })
                                            }}
                                            readonly={this.props.readonly}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: 300, marginTop: "7%" }}>
                                    <hr></hr>
                                    <p style={{ margin: 0, padding: 0 }}>{`${strings.Created}: ${moment.tz(this.props.selectedContactForEdit.ObjectAudit.CreatedDate, defaultTimeZone).format("MM/DD/YYYY hh:mm a")}`}</p>
                                    <p style={{ margin: 0, padding: 0 }}>{`${strings.Created_By}: ${this.props.selectedContactForEdit.ObjectAudit.CreatedByName}`}</p>
                                    <p style={{ margin: 0, padding: 0 }}>{`${strings.Modified}: ${moment.tz(this.props.selectedContactForEdit.ObjectAudit.LastModified, defaultTimeZone).format("MM/DD/YYYY hh:mm a")}`}</p>
                                    <p style={{ margin: 0, padding: 0 }}>{`${strings.Modified_By}: ${this.props.selectedContactForEdit.ObjectAudit.LastModifiedByName}`}</p>
                                </div>
                            </div>
                        </div>
                    </CardText>
                    <CardActions style={{ textAlign: "right" }}>
                        {!this.props.readonly &&
                            <FlatButton label={strings.Cancel} onTouchTap={() => this.props.closeDrawer()} />
                        }
                        <FlatButton
                            label={this.props.readonly ? strings.OK : strings.Save}
                            primary
                            keyboardFocused
                            onTouchTap={() => this.props.readonly ?
                                this.props.closeDrawer() :
                                this.updateClientData()
                            }
                        />
                    </CardActions>
                </Card>
            </div>
        )
    }
}